import { Component, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogRef,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { HelpFeaturesDialogInput, HelpFeaturesDialogResult } from './help-features-dialog';

interface HelpShortcutSection {
    title: string;
    shortcuts: { keys: string; action: string }[];
}

@Component({
    selector: 'phito-help-features-dialog',
    templateUrl: './help-features-dialog.component.html',
    styleUrl: './help-features-dialog.component.scss',
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton],
})
export class HelpFeaturesDialogComponent {
    dialogRef = inject<MatDialogRef<HelpFeaturesDialogComponent>>(MatDialogRef);
    input = inject<HelpFeaturesDialogInput>(MAT_DIALOG_DATA);

    sections: HelpShortcutSection[] = [
        {
            title: 'Allgemein',
            shortcuts: [
                {
                    keys: 'Alt + N',
                    action: 'Schnellnavigation öffnen',
                },
            ],
        },
        {
            title: 'Tabellen',
            shortcuts: [
                {
                    keys: 'Alt + S',
                    action: 'Suche fokussieren',
                },
                {
                    keys: 'Alt + F',
                    action: 'Filterdialog öffnen',
                },
                {
                    keys: 'Bild hoch / Pfeil links',
                    action: 'Vorherige Seite',
                },
                {
                    keys: 'Bild runter / Pfeil rechts',
                    action: 'Nächste Seite',
                },
            ],
        },
    ];

    close(confirmed: boolean) {
        this.dialogRef.close(new HelpFeaturesDialogResult(confirmed));
    }
}
